import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./i18n/i18n";
import reportWebVitals from "./reportWebVitals";
import TenantConfig from "./util/tenantConfig";
import Logger from "./redux/helpers/logger";
import MainApp from "./MainApp";
import AppErrorBoundary from "./components/AppErrorBoundary";

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

const initializeApp = async () => {
  try {
    let authInstance: any;
    const loadedConfig = await TenantConfig();
    if (loadedConfig.authentication === 'entraid') {
      await (async () => {
        const Azure = await import('@azure/msal-browser');
        const AzureConfig = await import('./authentication/EntraId/authConfig');
        
        authInstance = new Azure.PublicClientApplication(AzureConfig.msalConfig);

        authInstance.initialize().then(() => {
          authInstance.handleRedirectPromise().then((response: any) => {
            if (response) {
              // User just logged in via redirect
              authInstance.setActiveAccount(response.account);
            } else {
              // Check for existing accounts
              const accounts = authInstance.getAllAccounts();
              if (accounts.length > 0) {
                authInstance.setActiveAccount(accounts[0]);
              } else {
                // Auto-trigger login on first visit
                authInstance.loginRedirect();
              }
            }
          }).catch((error: any) => {
            console.error('Redirect error:', error);
          });

          authInstance.addEventCallback((event: any) => {
            if (event.eventType === Azure.EventType.LOGIN_SUCCESS && event.payload) {
              const payload = event.payload as any;
              const account = payload.account;
              authInstance.setActiveAccount(account);
            }
          });
        });
      })();
    }
    
    root.render(
      <React.StrictMode>
        {/* Outermost, so a render error anywhere — MainApp's own boot hooks
            included — shows a reload screen instead of a blank page. */}
        <AppErrorBoundary>
          <MainApp authInstance={authInstance} />
        </AppErrorBoundary>
      </React.StrictMode>
    );
  } catch(error){
    Logger.error('Authentication initialization error:', error);
    root.render(
      <div>
        <h1>Error</h1>
        <p>Authentication instance is not initialized. Please try again later.</p>
      </div>
    );
  }
};

initializeApp();

reportWebVitals();
